import { createContext, useContext, useEffect } from "react";

// Light-only mode. Dark/system themes are permanently disabled across the app.
// This provider is kept as a no-op shim so existing imports keep compiling
// while enforcing Light theme regardless of OS/system preference or any
// previously persisted user choice.

const ThemeCtx = createContext({ theme: "light", setTheme: () => {} });

function _forceLight() {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    root.classList.remove("dark");
    root.style.colorScheme = "light";
    try {
        // Wipe any legacy persisted theme so it can never re-apply.
        window.localStorage.removeItem("wmf_theme");
    } catch (_) { /* ignore */ }
}

export function ThemeProvider({ children }) {
    useEffect(() => {
        _forceLight();
        // Re-assert on any late class mutations (dev extensions, etc.)
        const mo = new MutationObserver(() => {
            if (document.documentElement.classList.contains("dark")) {
                document.documentElement.classList.remove("dark");
            }
        });
        mo.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
        return () => mo.disconnect();
    }, []);

    return (
        <ThemeCtx.Provider value={{ theme: "light", setTheme: () => {} }}>
            {children}
        </ThemeCtx.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeCtx);
}
